import { Trigger } from './trigger';
import { ContentList } from './content-list';

export class Content{

  type:string; // Video, QuestionSelect, .....
  hash:string;
  trigger:Trigger;

  videoReplay:boolean = false;
  replay:boolean = false;

  canvasX:number = 0;
  canvasY:number = 0;

  parentContentList:ContentList;
  triggeredTrigger:Trigger; // このContentをトリガーしたトリガー
  parentTriggers:Array<Trigger> = [];
  
  constructor(object = null){
    this.hash = this.generateHash();

    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.hash){
      this.hash = object.hash;
    }
    if(object.trigger){
      this.trigger = new Trigger(object.trigger);
      this.trigger.baseContent = this;
    }
    if(object.videoReplay){
      this.videoReplay = object.videoReplay;
    }
    if(object.replay){
      this.replay = object.replay;
    }
    if(object.canvasX){
      this.canvasX = object.canvasX; 
    }
    if(object.canvasY){
      this.canvasY = object.canvasY;
    }    
  }

  addParentTrigger(trigger:Trigger){
    this.parentTriggers.push(trigger);
  }

  isMainContent(){
    return this.parentContentList ? false : true;
  }
  isSubContent(){
    return this.parentContentList ? true : false;
  }

  // 次へボタンが利用可能かを判定
  availableNextBtn(){
    if(this.trigger){
      // 次のトリガーがあればtrue
      return true;
    }

    if(this.parentContentList && this.parentContentList.parentVideo){
      const video = this.parentContentList.parentVideo;
      
      // 次の動画があればtrue
      if(video.trigger){
        return true;
      }

      const trigger = this.parentContentList.parentTrigger;

      if(trigger){
        // contentListを発火するトリガーの開始位置が動画の最後から1秒以上前であればまだ再生できるとみなしtrue
        if(video.userVideo.time - trigger.seconds >= 1){
          return true;
        }
      }
    }    

    return false;    
  }

  generateHash(){
    // 生成する文字列の長さ
    var l = 12;

    // 生成する文字列に含める文字セット
    var c = "abcdefghijklmnopqrstuvwxyz0123456789";

    var cl = c.length;
    var r = "";
    for(var i=0; i<l; i++){
      r += c[Math.floor(Math.random()*cl)];
    }
    return r;
  }

}